import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {ValidationConstraint} from '../../domain/validation-constraint';
import {Directive, Input} from '@angular/core';
import * as _ from 'lodash';


@Directive({
    selector: '[appCustomPatternValidator]',
    providers: [{provide: NG_VALIDATORS, useExisting: CustomPatternValidatorDirective, multi: true}]
})
export class CustomPatternValidatorDirective implements Validator {
    @Input('appCustomPatternValidator') constraints: ValidationConstraint[];

    private errorMsg: string;

    validate(control: AbstractControl): { [key: string]: any } | null {

        let valid = true;
        if (this.constraints) {
            for (const constraint of this.constraints) {
                switch (constraint.pattern) {
                    case 'NULL':
                        valid = control.value === null;
                        break;
                    case 'NOT_NULL':
                        valid = control.value !== null && control.value !== undefined;
                        break;
                    case 'NOT_EMPTY':
                        valid = control.value !== null && control.value !== '';
                        break;
                    case 'EMAIL':
                        if (!control.value) {
                            valid = true;
                        } else {
                            const mailRegexp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,11}$');
                            valid = mailRegexp.test(control.value);
                        }
                        break;
                    case 'MIN':
                        if (constraint.parameters) {
                            const minValue = parseInt(constraint.parameters, 10);
                            if (control.value != null && control.value < minValue) {
                                valid = false;
                            }
                        }
                        break;
                    case 'MAX':
                        if (constraint.parameters) {
                            const maxValue = parseInt(constraint.parameters, 10);
                            if (control.value > maxValue) {
                                valid = false;
                            }
                        }
                        break;
                    case 'RANGE':
                        if (constraint.parameters) {
                            const arr = constraint.parameters.split(';');
                            if (arr.length === 2) {
                                const minValue = parseInt(arr[0], 10);
                                const maxValue = parseInt(arr[1], 10);
                                if (control.value < minValue || control.value > maxValue) {
                                    valid = false;
                                }
                            }

                        }
                        break;
                    case 'MIN_LENGTH':
                        if (control.value == null) {
                            valid = true;
                        } else if (constraint.parameters) {
                            const minLength = parseInt(constraint.parameters, 10);
                            valid = control.value?.length >= minLength;
                        }
                        break;
                    case 'TRUE':
                        valid = control.value;
                        break;
                    case 'NOT_BLANK':
                        let objToVal;
                        if (typeof control.value === 'object') {
                            if (_.has(control.value, constraint.field) || constraint.field.indexOf('.') === -1) {
                                objToVal = _.get(control.value, constraint.field);
                            } else {
                                const path = constraint.field.substring(constraint.field.lastIndexOf('.') + 1);
                                objToVal = _.get(control.value, path);
                            }
                            valid = objToVal && objToVal.toString().trim() !== '';
                        } else {
                            valid = control.value && control.value.toString().trim() !== '';
                        }

                        break;
                    default:
                        const re = new RegExp(constraint.pattern);
                        valid = re.test(control.value);
                }

                if (!valid) {
                    let errorMsg = constraint.errorMessage;
                    if (!errorMsg) {
                        switch (constraint.pattern) {
                            case 'TRUE':
                                errorMsg = 'Bitte bestätigen Sie';
                                break;
                            case 'NOT_NULL':
                            case 'NOT_EMPTY':
                            case 'NOT_BLANK':
                                errorMsg = 'Bitte machen Sie eine Angabe';
                                break;
                            case 'EMAIL':
                                errorMsg = 'Ungültige Email-Adresse';
                                break;
                            default:
                                errorMsg = 'Bitte überprüfen Sie Ihre Angaben';
                        }
                    }
                    this.setErrorMsg(errorMsg);
                    break;
                }
            }
        }
        return valid ? null : {'regexp': this.errorMsg};
    }

    private setErrorMsg(msg: string) {
        this.errorMsg = msg;
    }
}
